var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowtharrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 35,
    rx: 10,
    fill: "#4CE865"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2834_5649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2834_5649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4 24L12 22.6L17.3 17.3C17.8833 16.7167 18.5917 16.425 19.425 16.425C20.2583 16.425 20.9667 16.7167 21.55 17.3L22.7 18.45C22.9 18.65 23.1375 18.75 23.4125 18.75C23.6875 18.75 23.925 18.65 24.125 18.45L28.575 14H26V12H32V18H30V15.425L25.525 19.875C24.9417 20.4583 24.2333 20.75 23.4 20.75C22.5667 20.75 21.8583 20.4583 21.275 19.875L20.1 18.7C19.9167 18.5167 19.6833 18.425 19.4 18.425C19.1167 18.425 18.8833 18.5167 18.7 18.7L13.4 24Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowtharrow);
export default __webpack_public_path__ + "static/media/growtharrow.a890d373cdd677834a1bd0572442adca.svg";
export { ForwardRef as ReactComponent };